import { useEffect } from 'react';

const AuthInitializer = ({ checkAuth }) => {
  useEffect(() => {
    // Verificar la autenticación cuando el componente se monta
    checkAuth();
  }, [checkAuth]);

  // Este componente no renderiza nada
  return null;
};

export default AuthInitializer; 